import { oc } from '@orpc/contract';
import { listRunsInputSchema, listRunsOutputSchema } from '../schemas/runs.schemas.js';
export const listRunsContract = oc
    .route({
    method: 'GET',
    path: '/runs',
    tags: ['Runs'],
    summary: 'List test runs with filters, sorting and pagination',
})
    .input(listRunsInputSchema)
    .output(listRunsOutputSchema);
//# sourceMappingURL=list-runs.contract.js.map